/**
 * voice-v8 — Welches Soniox-Erkennungsmodell wir rufen. EINE Stelle. (04.11.2026)
 *
 * Soniox hat am 03.11.2026 STT v6 gebracht; v5 fällt am 15.12.2026 weg und wird danach selbst
 * auf v6 geleitet. Die Namen stehen NUR hier: Echtzeit (Browser-Diktat, /neun und der Buchungs-
 * name der Sprechtaste), Datei (Sprechtaste, Tagesaufnahme per scripts/speaker-transcript.py).
 *
 * ⚠️ Rückweg = diese eine Zeile je Art. Die Preistabelle (shared/dienst-preise.ts) rechnet
 *    ohne Versionsnummer und kennt v5 wie v6; alte Buchungszeilen mit v5 bleiben lesbar.
 * Doku und Messplan: docs/soniox-v6.md.
 */

/** Echtzeit-Erkennung (WebSocket, stt-rt.soniox.com). */
export const SONIOX_MODELL_ECHTZEIT = "stt-rt-v6";

/** Datei-Erkennung (HTTP /v1/transcriptions). */
export const SONIOX_MODELL_DATEI = "stt-async-v6";
